import LangSelectorVertical from "./LangSelectorVertical.component";

export default LangSelectorVertical;
